import { SectionHeader } from '~analytics-components/section-header';
import type { ResolvedPageFilter } from '~containers/analytics/overview-page/use-page-filter';
import { KpiCardFromSpec } from '../kpis/kpi-card-from-spec';
import type { KpiCardSpec } from '../kpis/card-spec';
import {
    DEMOGRAPHIC_BREAKDOWN_CARDS,
    PRODUCT_PREFERENCES_CARDS,
    REGIONAL_BREAKDOWN_CARDS,
    AGE_CARDS,
} from './cards';
import style from './style.module.scss';

export const DemographicSection = ({
    filter,
}: {
    filter: ResolvedPageFilter;
}) => {
    const renderCard = (spec: KpiCardSpec, index: number) => (
        <KpiCardFromSpec
            key={`${spec.source}-${spec.form}-${index}`}
            spec={spec}
            pageRange={filter.range}
            pageRegion={filter.provinces}
            compareEnabled={filter.compare}
            waveKey={filter.waveKey}
        />
    );

    return (
        <div className={style.dashboard}>
            <section className={style.section}>
                <SectionHeader title="Verification funnel" />
                <div className={style.dashboard_grid}>
                    {DEMOGRAPHIC_BREAKDOWN_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader title="Age-restricted product preferences" />
                <div className={style.dashboard_grid}>
                    {PRODUCT_PREFERENCES_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader title="Regional breakdown" />
                <div className={style.dashboard_grid}>
                    {REGIONAL_BREAKDOWN_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader title="Age distribution" />
                <div className={style.dashboard_grid}>
                    {AGE_CARDS.map(renderCard)}
                </div>
            </section>
        </div>
    );
};
